module.exports = __webpack_public_path__ + "img/image_score_base.35f1dc5a.png";